import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";

const OpinionsShow = ({ match }) => {
	const {
		params: { opinionID },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [name, setName] = useState("");
	const [position, setPosition] = useState("");
	const [opinion, setOpinion] = useState("");
	const [loading, setLoading] = useState(true);
	const [picture, setPicture] = useState(userPlaceholder);
	const [pictureName, setPictureName] = useState(userPlaceholder);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل رأي العميل",
				breadcrumb: "آراء العملاء",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${opinionID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setTitle(response.data.data.data.title);
				setDescription(response.data.data.data.description);
				setName(response.data.data.data.opinions[0].name);
				setPosition(response.data.data.data.opinions[0].position);
				setOpinion(response.data.data.data.opinions[0].opinion);
				setPicture(response.data.data.data.image);
				setPicture(
					`${process.env.REACT_APP_MAIN_URL}${response.data.data.data.image}`
				);
				setPictureName(response.data.data.data.image);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = e => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);

		const image = document.querySelector("#picture");
		if (image.files[0]) {
			const data = new FormData();
			data.append("file", image.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					const data = {
						title,
						description,
						image: response.data.data.name,
						opinions: [
							{
								name,
								position,
								opinion,
							},
						],
					};
					axios
						.put(
							`${process.env.REACT_APP_API_URL}/posts/${opinionID}`,
							{
								admin_id: auth.data.id,
								category_id: 9,
								data: data,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							toast.success("تم تحديث الرأي بنجاح!");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		} else {
			const data = {
				title,
				description,
				image: pictureName,
				opinions: [
					{
						name,
						position,
						opinion,
					},
				],
			};
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/posts/${opinionID}`,
					{
						admin_id: auth.data.id,
						category_id: 9,
						data: data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {
					toast.success("تم تحديث الرأي بنجاح!");
					setLoading(false);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										required
										value={title}
										onChange={e => setTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="description">الوصف</label>
									<input
										type="text"
										id="description"
										required
										value={description}
										onChange={e => setDescription(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="name">الاسم</label>
									<input
										type="text"
										id="name"
										required
										value={name}
										onChange={e => setName(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="position">الوظيفة</label>
									<input
										type="text"
										id="position"
										required
										value={position}
										onChange={e => setPosition(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="position">الرأي</label>
									<textarea
										id="position"
										cols="30"
										rows="2"
										onChange={e => setOpinion(e.target.value)}
										value={opinion}
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default OpinionsShow;
